import {
	FETCH_PROFILE_USER_BEGIN,
	FETCH_PROFILE_USER_SUCCESS,
	FETCH_PROFILE_USER_FAILURE,
	SIGN_OUT_PROFILE_USER_BEGIN,
	SIGN_OUT_PROFILE_USER_SUCCESS,
	SIGN_OUT_PROFILE_USER_FAILURE
} from '../actions/fetchAccorProfileUser'

import {
	FETCH_LOGIN_TOKEN_BEGIN,
	FETCH_LOGIN_TOKEN_SUCCESS,
	FETCH_LOGIN_TOKEN_FAILURE,
	FETCH_LOGIN_SESSIONS_SUCCESS,
} from '../actions/fetchAccorLoginToken'

import {
	FETCH_CENDYN_PROFILE_USER_START,
	FETCH_CENDYN_PROFILE_USER_FAILURE,
	FETCH_CENDYN_PROFILE_USER_SUCCESS,
} from '../actions/fetchCendynProfileUser'

import {
	FETCH_AUTH_CODE_START,
	FETCH_AUTH_CODE_FAILURE,
	FETCH_AUTH_CODE_SUCCESS
} from '../actions/fetchCendynLoginToken'

const initialState = {
	loading: false,
	error: null,
	user: null,
	token: null,
	tokenLoading: false,
	sessions: null
}

export default function fetchUserReducers(state = initialState, action) {
	switch(action.type) {
		case FETCH_PROFILE_USER_BEGIN:
		case SIGN_OUT_PROFILE_USER_BEGIN:
		case FETCH_CENDYN_PROFILE_USER_START:
			return {
				...state,
				loading: true,
				error: null
			}

		case FETCH_AUTH_CODE_START:
		case FETCH_LOGIN_TOKEN_BEGIN:
			return {
				...state,
				tokenLoading: true,
			}

		case FETCH_PROFILE_USER_SUCCESS:
		case FETCH_CENDYN_PROFILE_USER_SUCCESS:
			return {
				...state,
				loading: false,
				user: action.payload
			}

		case FETCH_AUTH_CODE_SUCCESS:
		case FETCH_LOGIN_TOKEN_SUCCESS:
			return {
				...state,
				tokenLoading: false,
				token: action.payload,
			}

		case SIGN_OUT_PROFILE_USER_SUCCESS:
			return {
				...state,
				loading: false,
				user: null,
				sessions: null,
				token: null,
				tokenLoading: false,
			}

		case FETCH_PROFILE_USER_FAILURE:
		case FETCH_LOGIN_TOKEN_FAILURE:
		case FETCH_AUTH_CODE_FAILURE:
		case SIGN_OUT_PROFILE_USER_FAILURE:
		case FETCH_CENDYN_PROFILE_USER_FAILURE:
			return {
				...state,
				loading: false,
				tokenLoading: false,
				error: action.payload.error
			}

		case FETCH_LOGIN_SESSIONS_SUCCESS:
			return {
				...state,
				sessions: action.payload
			}
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/fetchUserReducers.js